<template>
    <div class="pt-8 pb-48 px-2">
        <div v-if="loaded" class="max-w-screen-xl mx-auto flex flex-col">
            <router-link
                :to="'/lediga-parkeringsplatser/'"
                class="block flex flex-row items-center cursor-pointer w-2/3 sm:w-1/2 lg:w-3/12 mb-4 border-b-2 border-b-mimer-turquoise py-2">
                <svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="20" height="20">
                    <path
                        d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z" />
                </svg>
                <p class="text-sm md:text-base font-medium pl-2">Tillbaka till sökning</p>
            </router-link>

            <div v-if="notFoundError">
                <div class="w-full mt-16 mx-auto text-center">
                    <img class="inline h-48" src="../assets/undraw_car.svg" alt="" />
                    <div v-if="notFoundError">
                        <h1 class="text-3xl lg:text-5xl font-bold text-mimer-turquoise mb-4">Objektet hittades inte</h1>
                        <p>Tyvärr är inte det här objektet tillgängligt för intresseanmälan längre.</p>
                        <p>
                            Har du redan gjort en intresseanmälan? Du kan följa den på Mina Sidor.
                            <mimer-button
                                @click="redirectToNotedInterest"
                                text="Till Mina Sidor"
                                class="mx-auto mt-4" />
                        </p>
                    </div>
                </div>
            </div>
            <div v-else>
                <h1 class="text-5xl font-bold text-mimer-turquoise mb-4">
                    {{ currentParking.postalAddress }}
                </h1>
                <div class="flex flex-col xl:flex-row mb-4">
                    <div v-if="images.length > 0" class="w-full xl:w-4/6">
                        <div class="md:h-96 overflow-hidden flex items-center justify-center">
                            <img
                                v-on:click="toggleFullScreen()"
                                class="w-full cursor-pointer object-center ease-in-out duration-300"
                                :src="images[imgIndex].url"
                                alt="Bild av parkeringsplatsen" />
                        </div>
                        <div v-if="images.length > 1" class="flex flex-row justify-between items-center p-4">
                            <div
                                v-on:click="decreaseImgIndex()"
                                class="border border-gray-300 rounded-full p-4 text-center cursor-pointer hover:scale-105">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    id="Bold"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24">
                                    <path
                                        d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z" />
                                </svg>
                            </div>
                            <div
                                v-on:click="increaseImgIndex()"
                                class="border border-gray-300 rounded-full p-4 text-center cursor-pointer hover:scale-105">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    xmlns:svgjs="http://svgjs.com/svgjs"
                                    version="1.1"
                                    width="24"
                                    height="24"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 24 24"
                                    style="enable-background: new 0 0 512 512"
                                    xml:space="preserve">
                                    <g>
                                        <path
                                            xmlns="http://www.w3.org/2000/svg"
                                            d="M6.079,22.5a1.5,1.5,0,0,1,.44-1.06l7.672-7.672a2.5,2.5,0,0,0,0-3.536L6.529,2.565A1.5,1.5,0,0,1,8.65.444l7.662,7.661a5.506,5.506,0,0,1,0,7.779L8.64,23.556A1.5,1.5,0,0,1,6.079,22.5Z"
                                            fill="#000000"
                                            data-original="#000000" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div v-else class="w-full xl:w-4/6 flex items-center justify-center md:h-96">
                        <img class="h-48" src="../assets/undraw_car.svg" alt="" />
                    </div>

                    <div
                        class="flex h-60 md:h-96 xl:bg-gray-100 flex-row w-full xl:w-2/6 text-sm md:text-base items-center justify-center mb-2"
                        style="font-size: 0.9rem">
                        <div class="pr-2 font-bold text-right border-r border-black">
                            <p class="py-0">Adress</p>
                            <p class="py-0">Område</p>
                            <p class="py-0">Yta</p>
                            <p class="py-0">Hyra</p>
                            <p class="py-0">Tillgänglig från</p>
                            <p class="py-0">Typ</p>
                            <p class="py-0">Objektsnummer</p>
                        </div>
                        <div class="pl-2">
                            <p class="py-0">
                                {{ currentParking.postalAddress }}
                            </p>
                            <p class="py-0">{{ currentParking.district }}</p>
                            <p class="py-0">{{ currentParking.size }} m²</p>
                            <p class="py-0">
                                {{ Math.round(currentParking.monthRent.replace(',', '.')) }}
                                kr/månad
                                <span
                                    v-if="isExternalParkingSpace && currentParking.vatIncluded !== null"
                                    class="text-xs p-0">
                                    inkl. moms {{ currentParking.vatIncluded }}
                                </span>
                            </p>
                            <p class="py-0">
                                {{
                                    new Date().toISOString() >= currentParking.vacantFrom
                                        ? 'Omgående'
                                        : currentParking.vacantFrom.split('T')[0]
                                }}
                            </p>
                            <p class="py-0">
                                {{ currentParking.realEstateObjectTypeCaption }}
                            </p>
                            <p class="py-0">
                                {{ currentParking.rentalObjectCode }}
                            </p>
                        </div>
                    </div>
                </div>

                <additional-information :notes="currentParking.notes" />

                <div class="p-10 mb-10 bg-mimer-gray flex flex-col items-center text-sm md:text-base">
                    <span v-if="isExternalParkingSpace">
                        <span
                            v-if="isLoading"
                            class="mb-5 bg-mimer-gray flex flex-col items-center text-center text-sm md:text-base">
                            <b>Vi kollar om du uppfyller våra grundkrav. Stanna kvar på sidan, du får svar direkt.</b>
                        </span>

                        <span
                            v-else-if="!errorMessage"
                            class="bg-mimer-gray flex flex-col items-center text-sm md:text-base">
                            <span class="bg-mimer-gray flex flex-col items-center text-center text-sm md:text-base">
                                <b>Vill du hyra den här bilplatsen?</b>
                            </span>
                            <span class="md:w-2/3 pb-4">
                                <ul class="p-4">
                                    <li class="my-4 px-4">
                                        När du klickar på "Hyr bilplats" gör vi en kontroll direkt för att se om du
                                        uppfyller våra
                                        <a
                                            href="https://www.mimer.nu/hyra-och-bo/om-var-uthyrning/vara-grundkrav-for-att-hyra-bostad"
                                            target="_blank"
                                            >grundkrav</a
                                        >. Om du gör det är kontraktet ditt och avtalet bindande.
                                    </li>
                                    <li class="my-4 px-4">
                                        Du får då en bokningsbekräftelse till din registrerade mejladress. Därefter
                                        kommer ett nytt mejl med ditt kontrakt, som du signerar med BankID.
                                    </li>
                                    <li class="my-4 px-4">
                                        Du får börja parkera på platsen från det datum kontraktet börjar gälla.
                                    </li>
                                    <li class="my-4 px-4">
                                        Denna bilplats är Poängfri - du behöver inga köpoäng och du behåller dem du har.
                                    </li>
                                </ul>
                                <input type="checkbox" v-model="terms" name="terms" /><label for="terms" class="pl-4"
                                    >Jag godkänner ovanstående villkor för att hyra bilplats.</label
                                >
                            </span>
                        </span>
                    </span>
                    <div v-else-if="!noteofinterest" class="text-center md:w-2/3 s:w-full">
                        <b class="my-2">Vill du anmäla intresse för den här bilplatsen?</b>
                        <!-- If user does not already have parking space -->
                        <p v-if="!this.isParkingSpaceHolder">
                            Sista anmälningsdatum är {{ currentParking.publishedTo }}
                        </p>
                        <!-- If user does already have parking space and specific rental rules apply -->
                        <p v-if="this.hasActiveParkingSpaceWithSpecificRentalRulesInThisArea">
                            Du kan endast ha en (1) bilplats i det här området åt gången.<br />Om du vill byta din
                            tidigare bilplats i området mot denna vänligen kontakta Mimers kundcenter på 021-39 70 00
                            eller mejla kundcenter@mimer.nu så hjälper vi dig med intresseanmälan och uppsägning av
                            tidigare kontrakt.
                        </p>
                        <!-- If user does already have parking space -->
                        <p v-else-if="this.isParkingSpaceHolder">
                            Du hyr redan bilplats. Vill du byta bilplats eller hyra en till?
                        </p>
                        <!-- If user is not waiting for parking space -->
                        <p v-if="!this.isWaitingForParkingSpace">
                            Du står inte i kö för bilplats och har därför inga köpoäng. Genom att anmäla intresse för en
                            bilplats kommer du också att ställa dig i kö för bilplats och börja samla köpoäng.
                        </p>
                    </div>
                    <div
                        v-if="isAuthenticated && errorMessage && !isLoading"
                        class="my-4 flex flex-row justify-center text-center">
                        <div v-if="currentParking.waitingListType === 'Bilplats (extern)'">
                            <span class="bg-mimer-gray flex flex-col items-center text-center text-sm md:text-base">
                                <div class="my-4 flex flex-row justify-center text-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        xmlns:svgjs="http://svgjs.com/svgjs"
                                        version="1.1"
                                        width="24"
                                        height="24"
                                        x="0"
                                        y="0"
                                        viewBox="0 0 24 24"
                                        style="enable-background: new 0 0 512 512"
                                        xml:space="preserve">
                                        <g>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
                                                fill="#000000"
                                                data-original="#000000" />
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M12,5a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V6A1,1,0,0,0,12,5Z"
                                                fill="#000000"
                                                data-original="#000000" />
                                            <rect
                                                xmlns="http://www.w3.org/2000/svg"
                                                x="11"
                                                y="17"
                                                width="2"
                                                height="2"
                                                rx="1"
                                                fill="#000000"
                                                data-original="#000000" />
                                        </g>
                                    </svg>
                                    <b class="ml-4">Vi kan inte erbjuda dig bilplatsen</b>
                                </div>
                                <div
                                    v-if="errorMessage === 'External check failed'"
                                    class="py-4 items-center text-left">
                                    Vi har gjort en kreditupplysning och kan inte godkänna din ansökan om bilplats. Det
                                    kan exempelvis bero på att:
                                    <ul>
                                        <li class="my-4 px-4">
                                            Du har en eller flera betalningsanmärkningar de senaste 12 månaderna.
                                        </li>
                                        <li class="my-4 px-4">Du är inte skriven i Sverige.</li>
                                        <li class="my-4 px-4">Du har spärrat din person från kreditkontroller.</li>
                                    </ul>
                                    Vid frågor kontakta kundcenter på telefon 021- 39 70 00.
                                </div>
                                <p v-else-if="errorMessage === 'Internal check failed'">
                                    Du har ett inkassoärende hos oss de senaste 6 månaderna vilket gör att du inte
                                    uppfyller våra grundkrav.
                                </p>
                                <p v-else>
                                    Något gick fel. Försök igen lite senare eller kontakta oss på 021-39 70 00.
                                </p>
                            </span>
                        </div>
                        <div v-else class="my-4 flex flex-row justify-center text-center md:w-2/3">
                            <span class="bg-mimer-gray flex flex-col items-center text-center text-sm md:text-base">
                                <div class="my-4 flex flex-row justify-center text-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        xmlns:svgjs="http://svgjs.com/svgjs"
                                        version="1.1"
                                        width="24"
                                        height="24"
                                        x="0"
                                        y="0"
                                        viewBox="0 0 24 24"
                                        style="enable-background: new 0 0 512 512"
                                        xml:space="preserve">
                                        <g>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
                                                fill="#000000"
                                                data-original="#000000" />
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M12,5a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V6A1,1,0,0,0,12,5Z"
                                                fill="#000000"
                                                data-original="#000000" />
                                            <rect
                                                xmlns="http://www.w3.org/2000/svg"
                                                x="11"
                                                y="17"
                                                width="2"
                                                height="2"
                                                rx="1"
                                                fill="#000000"
                                                data-original="#000000" />
                                        </g>
                                    </svg>
                                    <b class="ml-4">Vi kan inte erbjuda dig bilplatsen</b>
                                </div>
                                <p class="" v-if="errorMessage === 'internal-credit-check-failed'">
                                    Du har ett inkassoärende hos oss de senaste 6 månaderna vilket gör att du inte
                                    uppfyller våra grundkrav.
                                </p>
                                <p v-else class="italic pl-2">{{ errorMessage }}</p>
                            </span>
                        </div>
                    </div>
                    <!-- If not authenticated -->
                    <div v-if="!isAuthenticated">
                        <!-- If parking is external -->
                        <mimer-button
                            v-if="isExternalParkingSpace"
                            @click="redirectToLogin"
                            text="Logga in för hyra bilplatsen" />
                        <!-- If parking is internal -->
                        <mimer-button
                            v-if="!isExternalParkingSpace"
                            @click="redirectToLogin"
                            text="Logga in för att anmäla intresse" />
                    </div>
                    <!-- If note of interest -->
                    <div v-if="noteofinterest" class="flex flex-col justify-center text-center">
                        <b>Du har anmält intresse för den här bilplatsen</b>
                        <p>
                            Vi börjar hantera din ansökan efter sista anmälningsdatum {{ currentParking.publishedTo }}
                        </p>
                        <!-- If note of interest can be deleted -->
                        <div v-if="noteofinterest.canBeDeleted" class="mx-auto">
                            <mimer-button @click="removeInterest" text="Ta bort intresseanmälan" />
                        </div>
                    </div>
                    <!-- If authenticated -->
                    <div v-if="isAuthenticated && !noteofinterest" class="w-full">
                        <!-- If there is no note of interest -->
                        <div>
                            <!-- If there is no noted interest -->
                            <div v-if="!errorMessage" class="flex justify-center items-start">
                                <!-- If loading -->
                                <div
                                    v-if="isLoading"
                                    class="mimer-button relative mx-auto mt-8"
                                    style="width: 125px; height: 60px">
                                    <img
                                        src="../assets/3-dots-scale-white-36.svg"
                                        class="absolute w-full top-0 left-0 h-full" />
                                </div>
                                <!-- If not loading and external parking space -->
                                <div v-else-if="isExternalParkingSpace">
                                    <mimer-button :disabled="!terms" @click="noteInterest" text="Hyr bilplats" />
                                </div>
                                <!-- If not loading and internal parking space and not specific rental rules -->
                                <div v-else-if="!hasActiveParkingSpaceWithSpecificRentalRulesInThisArea">
                                    <!-- If user already has parking space -->
                                    <div
                                        v-if="isParkingSpaceHolder"
                                        class="flex items-center justify-center text-center pt-8 space-x-3">
                                        <div class="flex flex-col w-1/3 mr-4">
                                            <b>Hyr en till bilplats</b>
                                            <p class="max-w-sm">
                                                Du behåller din nuvarande bilplats om du skulle få den här.
                                            </p>
                                            <div class="mx-auto">
                                                <mimer-button
                                                    v-if="isParkingSpaceHolder"
                                                    @click="noteInterest(false)"
                                                    text="Sök en till" />
                                            </div>
                                        </div>
                                        <div class="flex flex-col w-1/3 ml-4">
                                            <b>Byt bilplats</b>
                                            <p class="max-w-sm">
                                                Om du får den nya bilplatsen säger vi automatiskt upp kontraktet din
                                                nuvarande bilplats, när du tackar ja.
                                            </p>
                                            <div class="mx-auto">
                                                <mimer-button @click="noteInterest(true)" text="Byt bilplats" />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- If user does not already have a parking space -->
                                    <div v-if="!isParkingSpaceHolder" class="pt-8">
                                        <mimer-button @click="noteInterest" text="Anmäl intresse" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <MimerMap :address="currentParking.postalAddress"></MimerMap>
            </div>
        </div>
        <div v-if="!loaded" class="max-w-screen-xl mx-auto flex flex-col">
            <router-link
                :to="'/lediga-lagenheter/'"
                class="block flex flex-row items-center cursor-pointer w-2/3 sm:w-1/2 lg:w-3/12 mb-4 border-b-2 border-b-mimer-turquoise py-2">
                <svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="20" height="20">
                    <path
                        d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z" />
                </svg>
                <p class="text-xl font-medium pl-2">Tillbaka till sökning</p>
            </router-link>
            <div class="w-2/6 h-16 bg-gray-200 animate-pulse mb-4"></div>
            <div class="w-full h-96 bg-gray-200 animate-pulse mb-4"></div>
            <div class="w-3/6 h-16 bg-gray-200 animate-pulse mb-4"></div>
            <div class="w-3/6 h-96 bg-gray-200 animate-pulse mb-4"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { loggedInStatus, invalidateSession, createDateFormatter } from '../utils/helpers';
import { MimerButton } from 'mimer-components';
import MimerMap from '../components/Common/MimerMap.vue';
import AdditionalInformation from '@/components/Common/AdditionalInformation.vue';

export default {
    name: 'ParkingDetail',
    components: {
        MimerButton,
        MimerMap,
        AdditionalInformation,
    },
    data() {
        return {
            currentParking: null,
            loaded: false,
            images: [],
            imgIndex: 0,
            fullScreen: false,
            isLoading: false,
            isAuthenticated: Boolean(loggedInStatus()),
            noteofinterest: null,
            isParkingSpaceHolder: false,
            isWaitingForParkingSpace: false,
            hasActiveParkingSpaceWithSpecificRentalRules: false,
            hasActiveParkingSpaceWithSpecificRentalRulesInThisArea: false,
            errorMessage: null,
            notFoundError: false,
            isExternalParkingSpace: false,
            terms: false,
        };
    },
    methods: {
        redirectToLogin() {
            location.href = '/mina-sidor/?redirection=/sok-ledigt' + this.$route.path;
        },

        redirectToNotedInterest() {
            location.href = '/mina-sidor/erbjudanden/detalj?i=' + this.$route.params.id;
        },

        async noteInterest(changeParkingSpace) {
            if (this.isExternalParkingSpace && !this.terms) {
                return;
            }
            //Show loader
            this.isLoading = true;
            var requestBody = {
                rentalObjectCode: this.$route.params.id,
                changeParkingSpace: changeParkingSpace == true ? changeParkingSpace : false,
            };
            //Do the request
            let response = await axios.post(process.env.VUE_APP_API_URL + '/api/noteofinterests/', requestBody, {
                headers: { Authorization: `Bearer ${loggedInStatus()}` },
                validateStatus: function () {
                    return true;
                },
            });
            try {
                if (response.status === 204) {
                    if (this.isExternalParkingSpace) {
                        location.href = '/sok-ledigt/lediga-parkeringsplatser/nytt-kontrakt';
                        return;
                    } else {
                        location.href = `/sok-ledigt/lediga-parkeringsplatser/ny-intresseanmalan?publishedTo=${this.currentParking.publishedTo}`;
                        return;
                    }
                }
                if (response.status === 500) {
                    this.errorMessage = response.data.detail.replace('XPAND ERROR: ', '');
                }
                //Hide the loader
                this.isLoading = false;
            } catch (err) {
                //Hide the loader
                this.isLoading = false;
                console.error('Failed to update the account:', err);
                return err;
            }
        },

        async removeInterest() {
            let response = await axios.delete(
                process.env.VUE_APP_API_URL + '/api/noteofinterests/' + this.noteofinterest.code,
                {
                    headers: { Authorization: `Bearer ${loggedInStatus()}` },
                }
            );
            try {
                if (response.status === 204) {
                    await this.fetchObject();
                    this.noteofinterest = null;
                }
            } catch (err) {
                console.error('Failed to update the account:', err);
                return err;
            }
        },

        toggleFullScreen() {
            this.fullScreen = !this.fullScreen;
        },

        decreaseImgIndex() {
            if (this.imgIndex == 0) {
                this.imgIndex = this.images.length - 1;
            } else if (this.imgIndex > 0) {
                this.imgIndex = this.imgIndex - 1;
            }
        },

        increaseImgIndex() {
            if (this.imgIndex == this.images.length - 1) {
                this.imgIndex = 0;
            } else if (this.imgIndex < this.images.length - 1) {
                this.imgIndex = this.imgIndex + 1;
            }
        },
        async getApplicant() {
            if (loggedInStatus()) {
                await axios
                    .get(process.env.VUE_APP_API_URL + '/api/applicants/me/', {
                        headers: {
                            Authorization: `Bearer ${loggedInStatus()}`,
                        },
                    })
                    .then((res) => {
                        this.isParkingSpaceHolder = res.data.isParkingSpaceHolder;
                        this.isWaitingForParkingSpace = res.data.isWaitingForParkingSpace;
                        this.hasActiveParkingSpaceWithSpecificRentalRules =
                            res.data.hasActiveParkingSpaceWithSpecificRentalRules;
                    })
                    .catch((err) => {
                        console.log('err', err);
                        invalidateSession();
                        this.isAuthenticated = false;
                    });
            }
        },
        async getCurrentNote() {
            //If the user is logged in fetch all notes of interest to check the status against this object
            if (loggedInStatus()) {
                await axios
                    .get(process.env.VUE_APP_API_URL + '/api/applicants/me/noteofinterests/', {
                        headers: {
                            Authorization: `Bearer ${loggedInStatus()}`,
                        },
                    })
                    .then((res) => {
                        this.noteofinterest = res.data.find(
                            (n) => (n.rentalObjectCode === this.$route.params.id) & (n.status === 'current')
                        );
                    })
                    .catch((err) => {
                        console.log('err', err);
                        invalidateSession();
                        this.isAuthenticated = false;
                    });
            }
        },

        async fetchObject() {
            await axios
                .get(process.env.VUE_APP_API_URL + '/api/publishedRentalObjects/parkings/' + this.$route.params.id, {
                    headers: {
                        Authorization: `Bearer ${loggedInStatus()}`,
                    },
                })
                .then((parkingResp) => {
                    this.currentParking = {
                        ...parkingResp.data,
                        notes: parkingResp.data.notes.filter((item) => item !== '\n'),
                        publishedTo: createDateFormatter().format(new Date(parkingResp.data.publishedTo)),
                    };
                    this.isExternalParkingSpace = parkingResp.data.waitingListType === 'Bilplats (extern)';
                    this.images = this.currentParking.imageUrlList.filter((image) => image.caption == 'Building');

                    if (
                        this.hasActiveParkingSpaceWithSpecificRentalRules &&
                        this.currentParking.hasSpecificRentalRules
                    ) {
                        this.hasActiveParkingSpaceWithSpecificRentalRulesInThisArea = true;
                    }
                })
                .catch(async (err) => {
                    console.log('err', err);
                    this.notFoundError = true;
                });
        },
    },

    async mounted() {
        //If the user is logged in fetch all notes of interest and the applicant to check the status against this object
        await this.getCurrentNote();
        await this.getApplicant();

        //Fetch the rental object
        await this.fetchObject();

        this.loaded = true;
    },
};
</script>

<style>
.mimer-button:disabled,
.mimer-button[disabled] {
    opacity: 0.7;
    cursor: not-allowed;
}
</style>
